import seoReducerMap from 'wanderu-ducks-seo';

import IndexGuide from '../containers/IndexGuide/IndexGuide';

function onLoad(module, info, props, context) {
    context.store.inject(seoReducerMap);
}

export { onLoad };
export default IndexGuide;
